import React, { Component } from "react";
import { Select, Spin } from "antd";
import ScGridTable from "@/components/display/table/gridTableCore";
import { getStationOrEquRank } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";

class Top100Equipment extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      tableConfig: null,
      sortType: "0",
      sortOrder: "-1",
      dataSource: [],
      loading: false,
    };
  }

  componentWillMount() {
    // 预设表单配置项，防止gridTableCore初始化失败
    this.initTableConfig();
    this.handleGetDataSource();
  }

  /** */
  initTableConfig = () => {
    this.setState({
      tableConfig: {
        tableKey: "chargeSuccessTop10StationTable",
        tableColumns: [
          {
            name: "排名",
            key: "serial",
            colType: "textCol",
            align: "center",
          },
          {
            name: "设备",
            key: "stubId",
            colType: "textCol",
            align: "left",
            render: (text, record) => {
              return (
                <a
                  onClick={() => this.props.onAdd(
                    { key: "equChargeSuccessDetail", titleText: "设备充电成功率" },
                    {
                      equipmentInfo: record,
                    },
                  )}>
                  {text}
                </a>
              );
            },
          },
          {
            name: "订单总数",
            key: "totalOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "成功订单数",
            key: "successOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "失败订单数",
            key: "failureOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "成功率",
            key: "successRate",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text}%`;
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: this.state.dataSource,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
    });
  };

  // 类型排序改变事件
  sortTypeChange = async (value) => {
    await this.setState({
      sortType: value,
    });

    this.handleGetDataSource();
  };

  // 升降序改变事件
  sortOrderChange = async (value) => {
    await this.setState({
      sortOrder: value,
    });

    this.handleGetDataSource();
  };

  // 获取数据源
  handleGetDataSource = () => {
    this.setState({
      loading: true,
    });
    fetchHandler(getStationOrEquRank, {
      ...this.props.params,
      topNum: 100,
      sortType: this.state.sortType,
      sortWay: this.state.sortOrder,
      isStubGroup: 0,
      startTime: this.props.chooseDate
        ? this.props.chooseDate.format(this.getFormatter())
        : this.props.params.startTime,
      endTime: this.props.chooseDate
        ? this.props.chooseDate.format(this.getFormatter())
        : this.props.params.endTime,
      time: undefined,
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState(
          {
            dataSource: res.data,
          },
          () => {
            this.initTableConfig();
          },
        );
      }
      this.setState({
        loading: false,
      });
    });
  };

  getFormatter = () => {
    return this.props.timeType === "pickMonth" ? "YYYYMM" : "YYYYMMDD";
  };

  render() {
    const format = this.props.timeType === "pickMonth" ? "YYYY.MM" : "YYYY.MM.DD";

    return (
      <Spin spinning={this.state.loading}>
        <div className='section'>
          <div className='title-box'>
            <div className='title'>
              {this.props.chooseDate
                ? `${this.props.chooseDate.format(format)} TOP100设备`
                : "近7天设备充电情况"}
            </div>
            <div className='search-box'>
              <span className="select-label">排序方式：</span>
              <Select
                value={this.state.sortType}
                onChange={this.sortTypeChange}
                style={{ width: "120px", marginRight: "8px" }}>
                {this.props.sortTypeOptions.map((v) => (
                  <Select.Option value={v.value}>{v.name}</Select.Option>
                ))}
              </Select>
              <Select
                value={this.state.sortOrder}
                onChange={this.sortOrderChange}
                style={{ width: "120px" }}>
                {this.props.sortOrderOptions.map((v) => (
                  <Select.Option value={v.value}>{v.name}</Select.Option>
                ))}
              </Select>
            </div>
          </div>
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </Spin>
    );
  }
}

export default Top100Equipment;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/top100Equipment.js